import "./gallery.css";

const images = [
  "/assets/gallery/img1.jpg",
  "/assets/gallery/image2.jpeg",
  "/assets/gallery/image3.jpg",
  "/assets/gallery/image4.jpeg",
  "/assets/gallery/image5.jpeg",
  "/assets/gallery/image6.jpeg",
];

const Gallery = () => {
  return (
    <section className="gallery">
      <h2 className="gallery-title">My Gallery</h2>
      <p>
        A glimpse into my life through moments I’ve captured.
      </p>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <div className="gallery-card" key={index}>
            <img src={img} alt={`gallery-${index}`} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;